import React, { FunctionComponent } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import SvgFacebookIcon from '../generated/svg/facebook-icon'
import SvgInstagramIcon from '../generated/svg/instagram-icon'
import SvgLineIcon from '../generated/svg/line-icon'
import SvgMobileFaqIcon from '../generated/svg/mobile-faq-icon'
import SvgRedRecruitIcon from '../generated/svg/red-recruit-icon'
import SvgTiktokIcon from '../generated/svg/tiktok-icon'
import SvgYoutubeIcon from '../generated/svg/youtube-icon'

const Outer = styled.div`
  display: flex;
  gap: 0.5rem;
  align-self: center;
  position: fixed;
  z-index: 100;
  background-color: #fff;
  border-radius: 1.5rem;
  padding: 0.5rem 1rem;
  margin-top: -3rem;
`

const SnsIconItem = styled.a`
  display: block;
  svg {
    display: block;
    height: 2rem;
    @media (max-width: 32rem){
      height: 1.5rem;
    }
  }
`

const RecruitIconItem = styled.a`
  display: block;
  height: 2rem;
  position: fixed;
  right: 0;
  right: 1.5rem;
  svg {
    height: 2rem;
    width: auto;
    @media (max-width: 32rem){
      height: 1.5rem;
    }
  }
`

const FaqIconItem = styled(Link)`
  display: block;
  height: 2rem;
  position: fixed;
  left: 1.5rem;
  svg {
    height: 2rem;
    width: auto;
    @media (max-width: 32rem){
      height: 1.5rem;
    }
  }
`

type MobileSnsIconsProps = {

}
export const MobileSnsIcons: FunctionComponent<MobileSnsIconsProps> = () => {
  return <Outer>
    <RecruitIconItem href="/recruit" target="_blank"><SvgRedRecruitIcon /></RecruitIconItem>
    <SnsIconItem href="https://www.youtube.com/channel/UC0v4aEvZadTIMysWcsGyAAQ"><SvgYoutubeIcon /></SnsIconItem> {/* FIXME */}
    <SnsIconItem href="https://www.instagram.com/muronoki.kg/"><SvgInstagramIcon /></SnsIconItem> {/* FIXME */}
    <FaqIconItem to="/advantage#faq"><SvgMobileFaqIcon /></FaqIconItem>
  </Outer>
}